import { Factory, association } from 'miragejs';
import moment from 'moment-timezone';

export default Factory.extend({
  visitor: association(),
  location: association(),
  signedInAt: moment.now(),

  additionalGuests: 1,
  flowName: 'Flows::EmployeeScreening',
  isDelivery: false,

  afterCreate(entry, server) {
    const userData = server.createList('graphql/user-data', 3);
    const location = server.create('graphql/location');
    entry.update({ userData, location });
  },
});
